import * as React from 'react'

import OutlineButtonWithIcon from '../../atoms/Button/Outline/ButtonWithIcon'
import { RenderButtonEvents } from '../../atoms/Button/RenderButton'
import Headings from '../../atoms/Heading'
import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'
import Tag from '../../atoms/Tag'

interface Props {
  content?: any
  background?: any
  cardBackground?: string
  columnLayout?: string
  border?: boolean
  buttonDetails?: any
  buttonCards?: any
}

/**
 * Event Cards Component
 * @param content - Content from the CMS.
 */

const MoreEvents = ({
  content,
  background = 'white',
  cardBackground = 'white',
  columnLayout = '2',
  border = false,
  buttonDetails,
  buttonCards,
}: Props) => {
  const bgCardColor =
    cardBackground === 'purple'
      ? 'bg-purple-10'
      : cardBackground === 'orange'
        ? 'bg-orange-10'
        : cardBackground === 'teal'
          ? 'bg-teal-10'
          : 'bg-white'
  const columns = columnLayout === '3' ? 'xl:w-[32%]' : columnLayout === '4' ? 'xl:w-[23.6%]' : 'xl:w-[49%]'
  const layout = `md:w-[48.25%] lg:w-[48.7%] ${columns} md:max-w-[50%]`
  const bgColor =
    background === 'purple'
      ? 'bg-purple-10'
      : background === 'orange'
        ? 'bg-orange-10'
        : background === 'teal'
          ? 'bg-teal-10'
          : 'bg-white'

  const handleClick = (e, link) => {
    e.stopPropagation()
    window.location.href = link
  }

  return (
    <>
      {content.length > 0 && (
        <div className={`${bgColor} layoutSpacing`}>
          <div className="layout sectionSpacing w-full overflow-hidden">
            <div className="w-full md:w-3/4">
              <Headings content={'More dates and times'} variant="H2" classes="text-purple-100" />
            </div>
            <div className="flex flex-wrap justify-start gap-24 pt-32">
              {content?.map((item, index) => (
                <div
                  key={`${item?.fields?.eventId}-${index}`}
                  className={`flex ${border ? 'border border-neutral-50' : ''} overflow-hidden rounded-2xl hover:border-purple-100 ${bgCardColor} ${layout}`}
                >
                  <div className="p-24 md:p-32">
                    <div
                      className="cursor-pointer"
                      onClick={(e) =>
                        handleClick(e, `${buttonCards?.fields?.buttonLink}?eventId=${item?.fields?.eventId}`)
                      }
                    >
                      <Headings variant="H4" content={`${item?.fields?.title}`} classes="text-purple-100 pb-16" />
                    </div>
                    <Paragraph content={item?.fields?.eventDescription} classes="line-clamp-3" />
                    {item?.fields?.fundTypeValue && (
                      <div className="pt-32">
                        <Tag name={item?.fields?.fundTypeValue} />
                      </div>
                    )}
                    <div className="grow py-32">
                      <div className="flex items-center gap-8 pb-16">
                        <Image
                          imageUrl={item?.fields?.locationIcon?.fields?.file?.url}
                          altText={item?.fields?.locationIcon?.fields?.file?.title}
                          width="20"
                        />
                        <Paragraph content={item?.fields?.eventLocation} />
                      </div>
                      <div className="flex items-center gap-8">
                        <Image
                          imageUrl={item?.fields?.eventCalendarIcon?.fields?.file?.url}
                          altText={item?.fields?.eventCalendarIcon?.fields?.file?.title}
                          width="20"
                        />
                        <Paragraph
                          content={`${new Date(item?.fields?.startDate).toLocaleDateString('default', { day: 'numeric' })} ${new Date(item?.fields?.startDate).toLocaleDateString('default', { month: 'long' })}`}
                        />
                      </div>
                    </div>
                    <RenderButtonEvents
                      item={buttonCards}
                      link={`${buttonCards?.fields?.buttonLink}?eventId=${item?.fields?.eventId}`}
                      underline={false}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-center pt-32">
              <OutlineButtonWithIcon
                name="See all other events"
                variant="dark"
                link={buttonDetails.fields.buttonLink}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MoreEvents
